import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-people-unselected",
  "use": "icon-people-unselected-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-people-unselected\">\r\n  <g id=\"icon-people-unselected_椭圆_22\" data-name=\"椭圆 22\" fill=\"none\" stroke=\"#999\" stroke-width=\"1\">\r\n    <circle cx=\"12\" cy=\"12\" r=\"12\" stroke=\"none\" />\r\n    <circle cx=\"12\" cy=\"12\" r=\"11.5\" fill=\"none\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/people-unselected.svg
// module id = uCH8
// module chunks = 3